import { FormControlOptions } from '@miq/catalog';

export const BrandFormConfig: { [key: string]: FormControlOptions<any> } = Object.freeze({
  // Company contacts
  company_contact_role_addresses: {
    name: 'company_contact_role_addresses',
    type: 'array',
    controlsConfig: {
      id: [''],
      _mode: [null],
      _contact_id: [null], // ensure presence
      display_order: [null], // ensure presence
      prev_display_order: [null], // ensure presence
      company_id: [null], // ensure presence
      contact_id: [null], // ensure presence
      location_id: [null], // ensure presence - flat mirror of location.location_id (MIQ-36890)
      children: [],
    },
    children: {
      location: {
        name: 'location',
        type: 'group',
        controlsConfig: { location_id: [null] },
      },
      company_industry_classification: {
        name: 'company_industry_classification',
        type: 'array',
        controlsConfig: {
          id: [null],
          ref_naics_classification_desc: [null],
          primary_naics_code_f: [null],
        },
      },
    },
  },
});
